import React, { useEffect, useState } from 'react'
import incripstyle from './InscriptionReportDetailPage.module.css'
import mainLogo from '../../../assets/images/logo-new-green.webp'
import BackBar from '../../components/BackBar/BackBar';
import 'font-awesome/css/font-awesome.min.css';
import { BsPrinterFill } from "react-icons/bs";
import { useParams } from 'react-router-dom';

export default function InscriptionReportDetailPage() {

  const { author_id, event_id } = useParams();
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    fetch(
      `${process.env.REACT_APP_API_BASE_URL}authormeetapi/getInscriptionReport.php?author_id=${author_id}&event_id=${event_id}`
    )
      .then(res => res.json())
      .then(data => {
        // console.log("API:", data);
        setReportData(data.data || []);
      });
  }, [author_id, event_id]);

  console.log("STATE:", reportData);

  return (
    <>
      <div className={incripstyle.orderconmain} style={{ minHeight: '700px' }}>
        <div className='container'>
          <div className='row mb-4'>
            <div className='col-xl-12'>
              <BackBar />
            </div>
          </div>
          <div className='row justify-content-center'>
            <div className="col-lg-12">
              <div className={incripstyle.orderconmainBody}>
                <div className={incripstyle.orderconhead}>
                  <div className="row">
                    <div className="col-xl-6">
                      <div className={`${incripstyle.orderheadtitles} text-start`}>
                        <h4>Inscription Report</h4>
                        <p>Author: {reportData[0]?.first_name} {reportData[0]?.last_name} </p>
                        <p>School/Organization: {reportData[0]?.school_name}</p>
                      </div>
                    </div>
                    <div className="col-xl-6">
                      <div className='text-end'>
                        <img src={mainLogo} className={`${incripstyle.imglogo}`} />
                      </div>
                    </div>
                  </div>
                </div>
                <div className={incripstyle.ordertblbox}>
                  <div className="row">
                    <div className="col-xl-12">
                      <div className="table-responsive">
                        <table className={`${incripstyle.orderconfirmTable} table`}>
                          <thead>
                            <tr>
                              <th>ISBN</th>
                              <th>Book Title</th>
                              <th>Inscription Name</th>
                              <th>Recipient’s Name</th>
                              <th>Homeroom Teacher</th>
                              <th>Grade</th>
                            </tr>
                          </thead>
                          <tbody>
                            {reportData.map((item, index) => (
                              <tr key={index}>
                                <td>{item.isbn}</td>
                                <td>{item.title}</td>
                                <td>{item.inscription_name}</td>
                                <td>{item.inscription_st_full_name}</td>
                                <td>{item.inscription_teacher_name}</td>
                                <td className="text-center">{item.inscription_grade_level}</td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
